import { Box, Spinner } from '@chakra-ui/react';
import React from 'react';

const Index = () => {
  return (
    <Box justifyContent={'center'} display={'flex'} mx="auto" my={5}>
      <Spinner color="brand.500" />
    </Box>
  );
};

export default Index;
